var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.1,
    height: 15,
    viewBox: "0 0 14.1 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_share",
    "data-name": "icona share",
    transform: "translate(-168 -140.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_share-2",
    "data-name": "icona share",
    transform: "translate(164.5 138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_254",
    "data-name": "Tracciato 254",
    d: "M26.7,5.1A2.1,2.1,0,1,1,24.6,3,2.1,2.1,0,0,1,26.7,5.1Z",
    transform: "translate(-9.6)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_255",
    "data-name": "Tracciato 255",
    d: "M8.7,15.6a2.1,2.1,0,1,1-2.1-2.1A2.1,2.1,0,0,1,8.7,15.6Z",
    transform: "translate(0 -5.6)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_256",
    "data-name": "Tracciato 256",
    d: "M26.7,26.1A2.1,2.1,0,1,1,24.6,24,2.1,2.1,0,0,1,26.7,26.1Z",
    transform: "translate(-9.6 -11.2)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_257",
    "data-name": "Tracciato 257",
    d: "M12.885,20.265l4.781,2.786",
    transform: "translate(-4.472 -9.208)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_258",
    "data-name": "Tracciato 258",
    d: "M17.659,9.765l-4.774,2.786",
    transform: "translate(-4.472 -3.608)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_790",
    "data-name": "Rettangolo 790",
    transform: "translate(168 141)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.4c0b44619fb1221235cdd0fee3ff36fb.svg";
export { ForwardRef as ReactComponent };